import { ListLocationViewModel } from "client/Api/Documents/SharePoint/common";
import { EditorModes } from "client/Api/Documents/common";
import { createUrlRelativeToEnvironment } from "client_legacy/ndaw/navigator";
import { urlEncodeObject } from "client_legacy/ndaw/urlHelper";

function getSharePointDocumentsUrl(): string {
	return createUrlRelativeToEnvironment("Documents?store=SharePoint");
}

export function getSharePointSiteCollectionDocumentsUrl(siteCollectionId: string): string {
	return getSharePointDocumentsUrl() + `&siteCollectionId=${encodeURIComponent(siteCollectionId)}`;
}

export function getSharePointLocationUrl(location: ListLocationViewModel, folderId?: number | nil): string {
	const { siteUrl: spSiteUrl, listId } = location;
	return getSharePointDocumentsUrl() + "&" + urlEncodeObject({ spSiteUrl, listId, folderId });
}

export function getWebDavFolderUrl(serverId: number, folderId?: string) {
	let url = "/Documents?store=WebDav&serverId=" + serverId;
	if (folderId) {
		url += "&folderId=" + encodeURIComponent(folderId);
	}
	return createUrlRelativeToEnvironment(url);
}

export function getUrlToOpenDocumentInNewWorkspaceTab(
	fileId: number,
	location: ListLocationViewModel,
	editorMode: EditorModes | undefined
) {
	const params: any = {
		fileId: fileId,
		location: location
	};

	if (editorMode) {
		params.editorMode = editorMode;
	}

	const queryString: string = urlEncodeObject(params);
	const url = "Documents/SharePoint/FileEditor/WorkspaceInterfaceEditor?" + queryString;

	return createUrlRelativeToEnvironment(url);
}
